import { render } from "./GoalsIcon.vue?vue&type=template&id=c9029748"
import script from "./GoalsIcon.vue?vue&type=script&lang=js"
export * from "./GoalsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__